import type { FaireProductEntity } from "../../entity_types/product";

export const p_67mhpv436a: FaireProductEntity = {
  token: "p_67mhpv436a",
  type: "product",
  name: "Halloween Witches Broom Pen 12 / Dsp",
  brandToken: "b_9viz2xeqrn",
  brandName: "Geddes",
  imageUrl:
    "https://cdn.faire.com/fastly/6e5548db9c5da639bbac058e457b6d611c51a0fea4b14d5c007a23f085692d09.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca7104e9ea1a9c65032186c51f1732f7645bc38bbfe8931b9265ab3249b9c4d7.jpeg",
  ],
  priceDollars: 1.06,
  description:
    "It may not be a Nimbus 2000, but our witches broom pen really flies when young wizards and witches need to write. Each ballpoint pen has a wooden broomstick barrel with a bristle broom topper. It's a great holiday pen for getting into the Halloween season.\n\nNatural wood pens with witch broom toppers\n• Assortments: One style\n• Black ink\n• Approx. 9\" long",
  tags: [],
  msrpDollars: 2.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:33.432Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
